import { Button, Form, Input, message } from 'antd';
import React from 'react';
import { ReactComponent as EmailIcon } from "../../../assets/svgs/icons/email-icon.svg";
import { ReactComponent as PasswordIcon } from "../../../assets/svgs/icons/password-icon.svg";
import { UserManagerContainer } from '../UserManager.style';
import { Store } from '../../../store/Store';
import { signUpWithCognito } from '../userManagementUtils';
import { useNavigate } from 'react-router-dom';
import ConfirmCode from './ConfirmCode';

const SignUp = () => {
    const [isConfirmCode, setIsConfirmCode] = React.useState<boolean>(false);
    const [loading, setLoading] = React.useState<boolean>(false);
    const [userMail, setUserMail] = React.useState<string>("");
    const navigate = useNavigate();
    const handleLoginClick = () => {
        navigate('/login');
    };

    const handleSignUp = (values: any) => {
        if (!values.email || !values.password) {
            message.warning("Please enter email and password!")
            return;
        }
        if (!values.email.includes("@")) {
            message.warning("Please enter a valid email address.", 2);
            return;
        }
        Store.isInitialized = false
        setLoading(true)
        signUpWithCognito(values.email, values.password).then((result) => {
            message.success("User created successfully. Please check your email for the confirmation code.");
            setUserMail(values.email);
            setIsConfirmCode(true);
        }).catch((err) => {
            message.error(err?.message || "Failed to create user.");
        }).finally(() => {
            setLoading(false)
            Store.isInitialized = true
        });
    }

    return (
        <UserManagerContainer>
            <div className='login__block'>
                <div className="login_inner_box">
                    <div className='login_inner_top_box'>
                        <h2>LiDAR Atlas</h2>
                    </div>
                    <div className='login_inner_middle_box'>
                        <div className='login_middle_title_box'>
                            <h2>Sign Up</h2>
                            <p>Please fill all the mandatory fields to continue</p>
                        </div>
                        <div className='login__form__block'>
                            {
                                !isConfirmCode ? (
                                <Form
                                    name="normal_login"
                                    className="login-form"
                                    initialValues={{ remember: false }}
                                    onFinish={handleSignUp}
                                >
                                    <Form.Item
                                        name="email"
                                        rules={[{ required: true, message: 'Please Enter Email!' }]}
                                        className='form_input_field'
                                    >
                                        <Input size="large" prefix={<EmailIcon key="EmailIcon" />} placeholder="Email*" autoComplete="email" />
                                    </Form.Item>
                                    <Form.Item
                                        name="password"
                                        rules={[{ required: true, message: 'Please Enter Password!' }]}
                                        className='form_input_field'
                                        hasFeedback
                                    >
                                        <Input
                                            prefix={<PasswordIcon key="PasswordIcon" className="site-form-item-icon" />}
                                            type="password"
                                            size="large"
                                            placeholder="Password*"
                                            autoComplete="new-password"
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        name="confirm password"
                                        // rules={[{ required: true, message: 'Please Enter Password!' }]}
                                        className='form_input_field'
                                        dependencies={['password']}
                                        hasFeedback
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Please confirm your password!',
                                            },
                                            ({ getFieldValue }) => ({
                                                validator(_, value) {
                                                    if (!value || getFieldValue('password') === value) {
                                                        return Promise.resolve();
                                                    }
                                                    return Promise.reject(new Error('The new password that you entered do not match!'));
                                                },
                                            }),
                                        ]}
                                    >
                                        <Input
                                            prefix={<PasswordIcon key="PasswordIcon" className="site-form-item-icon" />}
                                            type="password"
                                            size="large"
                                            placeholder="Confirm Password*"
                                            autoComplete="new-password"
                                        />
                                    </Form.Item>
                                    <Form.Item>
                                        <Button htmlType="submit" size='large' className="user_control_btn" loading={loading}>
                                            Sign Up
                                        </Button>
                                    </Form.Item>
                                </Form>
                                ) :
                                (
                                   <ConfirmCode userMail={userMail} setIsConfirmCode={setIsConfirmCode}/>
                                )
                            }
                        </div>
                    </div>
                    <div className='login_inner_bottom_box'>
                        <span onClick={handleLoginClick}>Already have an account? Sign In</span>
                    </div>
                </div>
            </div>
        </UserManagerContainer>
    );
}

export default SignUp;
